
import ArchivoOrdenDePago from "../orden-archivo/orden-archivo.component";
import { obtenerArchivo } from "../../services/services";

const ArchivosOrdenDePago = ({ archivos }) => {

    const handleClick = (archivo, setLoading) => {
        setLoading(true)
        obtenerArchivo({
            "path": archivo.path,
            "fileName": `${archivo.name}${archivo.extension}`,
            "fileExtension": archivo.extension
        })
            .then(res => res.blob())
            .then(blob => {
                setLoading(false)
                var file = window.URL.createObjectURL(blob);
                window.open(file, '_blank');
            })
            .catch(error => {
                setLoading(false)
                console.log("error: ", error);
            })
    }

    return (
        archivos.length === 0 ? <p>Sin archivos...</p> :
            archivos.map(archivo =>
                <ArchivoOrdenDePago
                    key={archivo.name}
                    archivo={archivo}
                    callback={handleClick}
                />
            )
    );
}

export default ArchivosOrdenDePago;